export const IS_LOADING = 'IS_LOADING';
export const TOGGLE_MINI_MODE = 'TOGGLE_MINI_MODE';
export const USER_LOAD = 'USER_LOAD';
export const USER_DATA_LOAD = 'USER_DATA_LOAD';
export const LOAD_USER_ATTRIBUTES = 'LOAD_USER_ATTRIBUTES';
export const SET_ACTIVE_CATEGORY = 'SET_ACTIVE_CATEGORY';
export const LOAD_QR_CODE_SETTINGS = 'LOAD_QR_CODE_SETTINGS';

export const itemStatus = [
  { id: 0, label: 'aktivní' },
  { id: 1, label: 'dočasně smazaná' },
  { id: 2, label: 'trvale smazaná' },
];

export const attributeLevel = [
  { id: 1, label: 'kategorie' },
  { id: 4, label: 'produkt' },
];

export const itemServiceTypes = [
  { id: 1, label: 'rychlý' },
  { id: 2, label: 'klasický' },
];



// WEBPACK FOOTER //
// ./src/utils/constants/index.js